import styled from 'styled-components';
import {
  FormGroup,
  spacer16,
  spacer24,
  spacer48,
  spacer72,
  Type,
  HorizontalRule,
  screenSmMax,
} from '@spotify-internal/encore-web';

export const MobileHorizontalRule = styled(HorizontalRule)`
  display: none;
  @media (max-width: ${screenSmMax}) {
    display: block;
  }
`;

// TODO https://anchorfm.atlassian.net/browse/WHEEL-863: Consider turning this into a common Anchor component for consistent styling
export const Section = styled.section`
  margin-bottom: ${spacer72};
`;

export const HeadingContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${spacer48};
`;

export const MobileSaveContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: none;
  width: 100%;
  padding: ${spacer16} ${spacer16} ${spacer24} ${spacer16};
  text-align: center;
  background-color: #fff;
  box-shadow: 0px -2px 6px #dedfe0;
  @media (max-width: 600px) {
    display: block;
  }
`;

export const MobileSaveErrorText = styled.p`
  margin-bottom: ${spacer16};
  text-align: center;
`;

export const CustomURLLabel = styled(Type)`
  display: flex;
  gap: 4px;
`;

// TODO https://anchorfm.atlassian.net/browse/WHEEL-832: Figure out if Encore has a better way of horizontally aligning form labels and inputs
export const HorizontalFormGroup = styled(FormGroup)`
  display: grid;
  grid-gap: ${spacer24};
  grid-template-columns: max-content auto;
  align-items: flex-start;

  label {
    margin-top: ${spacer16};
  }
`;

// TODO https://anchorfm.atlassian.net/browse/WHEEL-900: Right align this on the label-row (currently difficult because the label is inline)
export const PendingEmailContainer = styled.span`
  margin-left: 5px;
  line-height: 1;
`;
